import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const ActivityFilter = () => {
	const {
		activityButtonId,
		setActivityButtonId,
		activityButtonActive,
		setActivityButtonActive,
		setExtraButtonId,
		setExtraButtonActive,
		setBranchButtonId,
		setBranchButtonActive,
		setActivityString,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	const activityFilterHandler = (event) => {
		if (activityButtonId === "") {
			setActivityString(event.target.value);
			setActivityButtonId(event.target.id);
			setActivityButtonActive(true);
		} else if (activityButtonId !== event.target.id) {
			setActivityString(event.target.value);
			setActivityButtonId(event.target.id);
			setActivityButtonActive(true);
			setExtraButtonId("");
			setExtraButtonActive(false);
			setBranchButtonId("");
			setBranchButtonActive(false);
		} else if (activityButtonId === event.target.id) {
			setActivityString("");
			setActivityButtonId("all");
			setActivityButtonActive(false);
			setExtraButtonId("");
			setExtraButtonActive(false);
			setBranchButtonId("");
			setBranchButtonActive(false);
		}
	};

	const base = '(terms.label:"Actie en avontuur" OR terms.label:"Moderne dans" OR terms.label:"Volksdans en werelddans" OR terms.label:"Fitness, gymnastiek, dans en vechtsport" OR terms.label:"Dance" OR terms.label:"Circus" OR terms.label:"Stijl en salondansen" OR terms.label:"Omnisport en andere" OR terms.label:"Ballet en klassieke dans" OR terms.label:"Atletiek, wandelen en fietsen" OR terms.label:"Zwemmen en watersport" OR terms.label:"Outdoor en adventure" OR terms.label:"Bal en racketsport")';

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.what}</h3>
			<div>
				<button
					id="beurs"
					value={`AND (${base} AND terms.label:"Beurs")`}
					onClick={activityFilterHandler}
					className={
						activityButtonActive && activityButtonId === "beurs"
							? "active"
							: ""
					}
				>
					{dictionaryWords.fair}
					<i id="beurs" className="fa fa-close"></i>
				</button>
				<button
					id="sportkamp"
					value={`AND terms.label:"Kamp of vakantie" AND ${base}'`}
					onClick={activityFilterHandler}
					className={
						activityButtonActive && activityButtonId === "sportkamp"
							? "active"
							: ""
					}
				>
					{dictionaryWords.sportCamp}
					<i id="sportkamp"className="fa fa-close"></i>
				</button>
				<button
					id="sportactiviteit"
					value='AND terms.label:"Sportactiviteit"'
					onClick={activityFilterHandler}
					className={
						activityButtonActive &&
						activityButtonId === "sportactiviteit"
							? "active"
							: ""
					}
				>
					{dictionaryWords.activity}
					<i id="sportactiviteit" className="fa fa-close"></i>
				</button>
				<button
					id="fiets_wandel"
					value='AND terms.label:"Fiets- of wandelroute"'
					onClick={activityFilterHandler}
					className={
						activityButtonActive &&
						activityButtonId === "fiets_wandel"
							? "active"
							: ""
					}
				>
					{dictionaryWords.cyclingWalking}
					<i id="fiets_wandel" className="fa fa-close"></i>
				</button>
				<button
					id="lezing_congres"
					value={`AND (${base} AND terms.label:"Lezing of Congres")`}
					onClick={activityFilterHandler}
					className={
						activityButtonActive &&
						activityButtonId === "lezing_congres"
							? "active"
							: ""
					}
				>
					{dictionaryWords.seminarConference}
					<i id="lezing_congres" className="fa fa-close"></i>
				</button>
				<button
					id="lessen_cursus_workshop"
					value={`AND (${base} AND terms.label:"Cursus of Workshop")`}
					onClick={activityFilterHandler}
					className={
						activityButtonActive &&
						activityButtonId === "lessen_cursus_workshop"
							? "active"
							: ""
					}
				>
					{dictionaryWords.coursesWorkshops}
					<i id="lessen_cursus_workshop" className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default ActivityFilter;
